import { useQuery } from '@tanstack/react-query';
import useViewportSpy from 'beautiful-react-hooks/useViewportSpy';
import clsx from 'clsx';
import { memo, useRef } from 'react';

import NormalHeader from './NormalHeader';
import StickyHeader from './StickyHeader';

import { getEditorialByTagQuery } from '@queries/editorial';
import { withErrorBoundary } from '@shared/ErrorBoundary';
import { isEmpty } from '@utilities/collection-utils';
import { competitionCode } from '@utilities/WindowContext';

import * as styles from './styles.module.scss';

const TICKETING_HEADER_TAG = `${competitionCode}.TICKETING.HEADER`.toUpperCase();

const Header = () => {
  const headerRef = useRef(undefined);
  const isVisible = useViewportSpy(headerRef, { rootMargin: '-37px 0px 0px 0px' });

  const { data: article } = useQuery({
    ...getEditorialByTagQuery(TICKETING_HEADER_TAG),
    placeholderData: {},
  });

  return (
    <>
      <header className={clsx(styles.ticketingHeader, 'pk-overflow--hidden')} pk-theme='dark' ref={headerRef}>
        {!isEmpty(article) && <NormalHeader article={article} />}
      </header>
      {!isEmpty(article) && !isVisible && <StickyHeader article={article} />}
    </>
  );
};

export default withErrorBoundary(memo(Header));
